





import { Component, Vue, Watch } from 'vue-property-decorator'
import { getRichTextContent } from '_user/api'
import { LoyoutModule } from '@/store/modules/layout'

@Component
export default class extends Vue {
  content = ''
  id = (this.$route.query.id as string) || ''
  get pageId() {
    return this.$route.query.id as string
  }
  @Watch('pageId')
  onPageIdChange() {
    this.id = this.pageId
    this.init()
  }
  async init() {
    const params = { id: this.id }
    const { data } = await getRichTextContent(params)
    this.content = data.postContent
    LoyoutModule.setTitle(data.postTitle)
  }
  created() {
    this.init()
  }
}
